module.exports = __webpack_public_path__ + "img/pojy.eabb5c24.png";